import { api } from "@/lib/api/api";
import { config } from "@/lib/shared/config";
import { path } from "@/lib/path/path";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { formatEvent } from "@/lib/event/format-event";
import { out } from "@/lib/output/out";
import { followSessionLogs } from "@/commands/show/follow-session-logs";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";
export async function showLogs(parsed: ParsedArgs): Promise<void> {
  args.expect(parsed, {
    flags: ["after", "limit"],
    booleans: ["follow"],
    positional: 2,
  });

  const sessionId = args.required(parsed, 1, "sessionId");
  const asJson = parsed.booleans.has("json");
  const after = args.integer(parsed, "after", { min: 0 });

  if (parsed.booleans.has("follow")) {
    await followSessionLogs(parsed, sessionId, after, asJson);
    return;
  }

  const page = expectShape<ApiOutputs["sessions"]["events"]>(
    await api(path`/sessions/${sessionId}/events`, {
      query: {
        after,
        limit: args.integer(parsed, "limit", { min: 1, max: 200 }),
      },
    }),
    "GET /sessions/{id}/events",
    { items: is.array },
  );

  if (asJson) {
    out.json(page);
    return;
  }

  const { baseUrl } = config.load();
  for (const event of page.items) {
    const line = formatEvent(event, baseUrl);
    if (line) {
      out.line(line);
    }
  }

  // Never let a truncated transcript look complete. Formatted events do not
  // carry their sequence, so the continuation cursor has to be spelled out.
  if (page.hasMore && page.nextCursor !== null) {
    out.line();
    out.line(
      out.paint(
        `more events: hepha sessions logs ${sessionId} --after ${page.nextCursor}`,
        "dim",
      ),
    );
  }
}
